import Input from './input/index.vue'
import SingleSelect from './singleSelect/index.vue'
import MultipleSelect from './multipleSelect/index.vue'
import Date1 from './date1/index.vue'
import Date2 from './date2/index.vue'
import Date3 from './date3/index.vue'
import Date3Gai from './date3Gai/index.vue'
import Date5 from './date4Gai/index.vue'
import Phone from './phone/index.vue'
import InputGai from './inputGai/index.vue'
import Radio from './radio/index.vue'
import Cascade from './cascade/index.vue'
import Checkbox from './checkbox/index.vue'
import UploadImg from './uploadImg/index.vue'
import UploadFile from './uploadFile/index.vue'
import MemberMultipleSelection from './memberMultipleSelection/index.vue'
import MemberSingleSelection from './memberSingleSelect/index.vue'
import MultipleDepartment from './multipleDepartment/index.vue'
import SingleDepartment from './singleDepartment/index.vue'
import Quote from './quote/index.vue'
import Mapping from './mapping/index.vue'
import Tags from './tags/index.vue'
import AssociatedData from './associatedData/index.vue'
import Address from './address/index.vue'
import Money from './money/index.vue'
import Landline from './landline/index.vue'
import referralPerson from './referralPerson/index.vue'
import referralPersonSource from './referralPersonSource/index.vue'
import uploadImgIncome from './uploadImgIncome/index.vue'
import { RxkArea } from '@/components/common/RxkArea'
import Citys from '@/components/restructure/city/index.vue'
import CustomeDate from '@/components/restructure/date/index.vue'
import Guarantee from './guarantee/index.vue'
import ErpProduct from './erpProduct/index.vue'
import FlairSelect from '@/views/ryt/base/components/flairSelect.vue'
import QuickTime from './timeQuick/index.vue'

import type { App } from 'vue'
const components = {
  'w-input': Input,
  'w-singleSelect': SingleSelect,
  'w-multipleSelect': MultipleSelect,
  'w-date1': Date1,
  'w-date2': Date2,
  'w-date3': Date3,
  'w-phone': Phone,
  'w-inputGai': InputGai,
  'w-radio': Radio,
  'w-cascade': Cascade,
  'w-checkbox': Checkbox,
  'w-uploadImg': UploadImg,
  'w-uploadImgIncome': uploadImgIncome,
  'w-uploadFile': UploadFile,
  'w-personMultiple': MemberMultipleSelection,
  'w-person': MemberSingleSelection,
  'w-multipleDepartment': MultipleDepartment,
  'w-department': SingleDepartment,
  'w-quote': Quote,
  'w-mapping': Mapping,
  'w-tags': Tags,
  'w-associatedData': AssociatedData,
  'w-address': Address,
  'w-money': Money,
  'w-landline': Landline,
  'w-date3Gai': Date3Gai,
  'w-referralPerson': referralPerson,
  'w-referralPersonSource': referralPersonSource,
  'w-date5': Date5,
  'w-cascCity': RxkArea,
  'w-citys': Citys,
  'w-customeDate': CustomeDate,
  'w-guarantee': Guarantee,
  'w-erpProduct': ErpProduct,
  'w-flairSelect': FlairSelect,
  'w-quickTime': QuickTime
}

export function registerGlobalFormComp(Vue: App) {
  Object.entries(components).forEach(([name, comp]) => {
    Vue.component(name, comp)
  })
}
// 组件名称的枚举
const obj: Recordable = {}
export const customCompNameEnums = Object.keys(components).reduce((prev, cur) => {
  prev[cur.slice(2)] = cur
  return prev
}, obj)
// console.log(customCompNameEnums, 'customCompNameEnums111')
